import { render, staticRenderFns } from "./adminNotificaciones.vue?vue&type=template&id=3c36328f&scoped=true&"
import script from "./adminNotificaciones.vue?vue&type=script&lang=js&"
export * from "./adminNotificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36328f",
  null
  
)

export default component.exports